import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { getConfig } from '@edx/frontend-platform';

export default function LmsHtmlFragment({
  className,
  html,
  title,
  ...rest
}) {
  const wholePage = `
    <html>
      <head>
        <base href="${getConfig().LMS_BASE_URL}" target="_parent">
        <link rel="stylesheet" href="/static/${getConfig().LEGACY_THEME_NAME ? `${getConfig().LEGACY_THEME_NAME}/` : ''}css/bootstrap/lms-main.css">
        <style>
          body {
            color: #1b1b1b;
            font-family: "Open Sans", sans-serif;
          }
          body.small {
            font-size: 0.875rem;
          }
          a {
            text-decoration: none;
            color: #0052a5;
          }
          a:hover {
            color: #006cd7;
            text-decoration: underline;
          }
          a:focus {
            outline: 2px solid #1b1b1b;
          }
          a[target=_blank]::after {
            display: inline-block;
            font-family: "gov-icons";
            content: "";
            font-size: 1.4rem;
            vertical-align: top;
            line-height: 1rem;
          }
        </style>
      </head>
      <body class="${className}">${html}</body>
    </html>
  `;

  const iframe = useRef(null);
  function handleLoad() {
    iframe.current.height = iframe.current.contentWindow.document.body.scrollHeight;
  }

  return (
    <iframe
      className="w-100 border-0"
      onLoad={handleLoad}
      ref={iframe}
      referrerPolicy="origin"
      scrolling="no"
      srcDoc={wholePage}
      title={title}
      {...rest}
    />
  );
}

LmsHtmlFragment.defaultProps = {
  className: '',
};

LmsHtmlFragment.propTypes = {
  className: PropTypes.string,
  html: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
